import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Chapters } from "@/components/Chapters";
import { EnrollmentCTA } from "@/components/EnrollmentCTA";
import { Disclaimer } from "@/components/Disclaimer";
import { SocialStrip } from "@/components/SocialStrip";
import { Footer } from "@/components/Footer";
import { api } from "@/lib/api";

export default function LandingPage() {
  useEffect(() => {
    api.post("/visits").catch(() => {});
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-slate-50">
      <Navbar />
      <Hero />
      <Marquee />
      <Chapters />
      <EnrollmentCTA />
      <Disclaimer />
      <SocialStrip />
      <Footer />
    </div>
  );
}
